<template>
  <div
    v-if="env"
    class="sticky-top border pt-1 px-4 bg-light small text-dark text-center"
    style="height: 2rem"
  >
    <strong>
      User Acceptance Testing - v{{version}} {{env}}
    </strong>
  </div>
</template>

<script>
export default {
  name: 'banner-environment',
  computed: {
    version() {
      let _version = window.config ? window.config.version : ''
      return _version
    },
    env() {
      let env = window.config ? window.config.environment : 'n/a'
      return env === 'prod' ? '' : env
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/banner-environment.vue